/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/hook-use-state */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useContext } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { API_URL } from "utils/constant";
import { UserContext } from "utils/reducers/user";
import { showToast } from "utils/helper";
import httpClient from "utils/apis/http-client";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  DatePicker,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { CirclePlusIcon, CircleX } from "lucide-react";
import {
  useCancelHandoverRequest,
  useGetHandoverRequests,
} from "utils/apis/handover.api";
import { formatDate } from "date-fns";

const apiUrl = API_URL;

const currentDate = new Date();

function ConsignmentsHandover() {
  const user = useContext(UserContext);

  const [operationDate, setOperationDate] = useState(currentDate);
  const [handoverRequests, setHanoverRequests] = useState([]);

  const { data: handoverRequestsData, isPending: loader } =
    useGetHandoverRequests({
      cashCenterId: user.CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
    });

  const { mutate: cancelRequest } = useCancelHandoverRequest();

  useEffect(() => {
    if (handoverRequestsData?.length) setHanoverRequests(handoverRequestsData);
  }, [handoverRequestsData]);

  const onOperationDateChanged = (value: Date) => {
    setOperationDate(value);
  };

  function CancelButtonCell({ dataItem }: any) {
    const { requestId } = dataItem;

    return (
      <td className="text-center mt-3">
        <Button
          variant="destructive"
          className="rounded-md w-full"
          onClick={() => {
            cancelRequest(requestId as string);
          }}
        >
          <CircleX />
        </Button>
      </td>
    );
  }

  function DetailComponent(props: any) {
    const data = props.dataItem.details;

    if (data) {
      return (
        <Grid data={data}>
          <Column field="orderId" title="Order No" />
          <Column field="jobNo" title="Job No" />
          <Column field="serviceType" title="Service Type" />
          <Column field="jobType" title="Job Type" />
          <Column field="status" title="Status" />
          <Column field="reasons" title="Reasons" />
        </Grid>
      );
    }

    return (
      <div
        style={{
          height: "50px",
          width: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
          }}
        >
          <div className="k-loading-image" />
        </div>
      </div>
    );
  }

  const expandChange = async (event: any) => {
    event.dataItem.expanded = event.value;

    const index = event.dataIndex;

    setHanoverRequests([...handoverRequests]);

    if (!event.value || event.dataItem.detail) {
      return;
    }

    const data: any = handoverRequests.slice();

    const requestId = event.dataItem.requestId;

    const servicesEndpoint = `${apiUrl}/daily/operations/handover/request/jobs/${requestId}`;

    try {
      await httpClient.get(servicesEndpoint).then((res: any) => {
        if (res.status === 200) {
          data[index].details = res.data;
          setHanoverRequests(data);
        } else {
          data[index].details = [];
          setHanoverRequests(data);
          showToast("error", "No open services found.");
        }
      });
    } catch (error) {
      data[index].details = [];
      setHanoverRequests(data);
      showToast("error", "No open services found.");
    }
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Consignments Handover</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex justify-end gap-4">
            {/* {isOperationAllowed(Permissions.Handover, Permissions.Add) ? ( */}
            <Link to="/create-consignments-handover">
              <Button variant="secondary" className="w-max gap-2">
                <CirclePlusIcon /> Create Request
              </Button>
            </Link>
            {/* ) : null} */}
            <div className="w-[250px]">
              <DatePicker
                placeholder="Select Operation Date"
                selectedDate={operationDate}
                onSelectDate={onOperationDateChanged}
              />
            </div>
          </div>
          <div className="border-b my-3 bg-accent" />

          {loader ? (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image" />
              <div className="k-loading-color" />
            </div>
          ) : (
            <Grid
              data={handoverRequests}
              detail={DetailComponent}
              expandField="expanded"
              onExpandChange={expandChange}
            >
              <Column field="donarRouteNo" title="Donar Route" width={200} />

              <Column
                field="receiverRouteNo"
                title="Receiving Route"
                width={200}
                className="text-center"
              />

              <Column field="operationDate" title="Operations Date " />

              <Column field="createDateTime" title="Create Date & Time" />

              <Column field="handoverTime" title="Handover Date & Time" />

              <Column field="handoverReason" title="Handover Reason" />

              <Column
                field="status"
                title="Status"
                width={200}
                className="text-center"
              />
              <Column
                width="80"
                title="Cancel"
                className="text-center"
                filterable={false}
                cell={CancelButtonCell}
              />
            </Grid>
          )}
        </CardContent>
      </Card>
    </Layout>
  );
}

export default ConsignmentsHandover;
